const FERequestsType = Object.freeze({
  MyRequests: 0,
  ApprovedReviewRequests: 1,
  SubmittedReviewRequests: 2,
  PendingEVPReviewRequests: 3,
});
export default FERequestsType;
